(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    

jQuery(function($){


 $('form').on('submit', function(event) {


		var pickUptime = $('#pickupTime').val();         
    
          
        var note_validator = $('#date').val();



		var email = $('#email').val();

		var phone = $('#phone_num').val();


 
        if( email == '' ){
          
          $('#email').css({borderColor:'red', background:'#fbfbfb'});
        
          alert('Please enter your email ID');
          
          event.preventDefault();

			
        
        }



        if( phone == '' ){

          
          $('#phone').css({borderColor:'red', background:'#fbfbfb'});
        
          alert('Please enter your mobile number');
          
          event.preventDefault();
		
        
        }





        
        if( note_validator == '' ){
          
          $('#date').css({borderColor:'red', background:'#fbfbfb'});
        
          alert('Please select a date for delivery or pickup');
          
            event.preventDefault();

			
        
        }


 


 else if ($('.location:checked').length == 0) {  alert('Please Select the Location');

 event.preventDefault();



}




 else if ($('.delivery_option:checked').length == 0) {  alert('Please Select the Delivery Option');

 event.preventDefault();



}




          
          else{
            
              $('#date').css({borderColor:'green'});
            
            $( "<br><em>Continue to checkouts... </em>" ).insertAfter( "#date" );
        
          //  $(this).submit();
            
          
          }
          
         
          
        });





$('.delivery_option').each(function(){


	$(this).click(function(){


			var pickVal = $(this).val();

		
			if(pickVal=='Pickup'){


$('.pickupTime').show();

$('#pickupTime').attr('required', 'required');


				


}

			if(pickVal=='Shipping'){ $('.pickupTime').hide(); 
			$('#pickupTime').attr('required', false); }


})

})

        



})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-columns"] && !Shopify.designMode) return;
  try {
    

$(function(){

  $('.slider').slick({

 slidesToShow: 3,
  slidesToScroll: 1,
	dots: true,
 arrows: false,


  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
 arrows: true
      }
}

]

}

);

})


  } catch(e) { console.error(e); }
})();
})();
